import React, { useState, useRef, useEffect, ReactNode } from "react";
import { IoIosArrowDown } from "react-icons/io";
import { AiOutlineDownload } from "react-icons/ai";

interface DownloadChartProps {
  children?: ReactNode;
  isFit?: boolean;
}

const DownloadChart: React.FC<DownloadChartProps> = ({ children, isFit = false }) => {
  const [isOpen, setIsOpen] = useState(false);

  // handle outside click event
  const singleDropdownRef = useRef<HTMLDivElement>(null);
  // Handle clicks outside of the dropdown
  const handleClickOutside = (event: MouseEvent) => {
    if (
      singleDropdownRef.current &&
      !singleDropdownRef.current.contains(event.target as Node)
    ) {
      setIsOpen(false);
    }
  };
  useEffect(() => {
    // Attach the click event listener to the document body
    document.addEventListener("click", handleClickOutside);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  // end

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="relative" ref={singleDropdownRef}>
      <div
        onClick={toggleDropdown}
        className={`border rounded-md bg-white flex items-center ${isFit ? "w-fit gap-x-3" : "w-full gap-x-6 justify-between"} p-3 text-left focus:outline-none cursor-pointer`}
      >
        <span>
          <AiOutlineDownload className="w-4 h-4" />
        </span>
        <IoIosArrowDown
          className={`w-4 h-4 transform ${isOpen ? "rotate-180" : ""}`}
        />
      </div>
      {isOpen && (
        <div
          className={`absolute z-30 mt-2 w-full bg-white border rounded-md shadow-sm`}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default DownloadChart;
